import { render } from "./PageIndexFive.vue?vue&type=template&id=07e83378"
import script from "./PageIndexFive.vue?vue&type=script&lang=js"
export * from "./PageIndexFive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__